import React, { useEffect, useState } from 'react';
import client from '../../sanityClient';
import imageUrlBuilder from '@sanity/image-url';
import { PortableText } from '@portabletext/react';

import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import Spacing from '../Spacing';
import { pageTitle } from '../../helpers/PageTitle';

const builder = imageUrlBuilder(client);
const urlFor = (src) => builder.image(src).width(800).url();

const components = {
  types: {
    image: ({ value }) => {
      if (!value?.asset?._ref) return null;
      return (
        <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
          <img
            src={urlFor(value)}
            alt={value.alt || 'Blog image'}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </div>
      );
    },
  },
  marks: {
    link: ({ children, value }) => {
      const target = value?.href?.startsWith('http') ? '_blank' : undefined;
      return (
        <a
          href={value?.href}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          style={{ textDecoration: 'underline', color: 'inherit' }}
        >
          {children}
        </a>
      );
    },
  },
};

export default function BlogDetails() {
  const [post, setPost] = useState(null);

  useEffect(() => {
    pageTitle('News');

    client
      .fetch(
        `*[_type == "post"] | order(publishedAt desc)[0]{
          title,
          publishedAt,
          coverImage,
          body
        }`
      )
      .then((data) => setPost(data))
      .catch(console.error);
  }, []);

  if (!post) return <p>Loading...</p>;

  return (
    <>
      <Section topMd={170} bottomMd={10} bottomLg={10}>
        <Breadcrumb title={post.title} />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            <div className="cs_blog_details_date">
              {new Date(post.publishedAt).toLocaleDateString()} 
            </div>
          </div>
        </div>
        <Spacing md="55" />
        <div className="cs_blog_details">
          <PortableText value={post.body} components={components} />
        </div>
        <Spacing md="135" lg="100" />
      </div>
    </>
  );
}
